/**
 * Validates an email address using a comprehensive regex pattern.
 * @param email The email address to validate
 * @returns boolean indicating if the email is valid
 */
const isValidEmail = (email: string): boolean => {
  const emailPattern =
    // eslint-disable-next-line max-len
    /^[a-zA-Z0-9](?!.*\.{2})(?:[a-zA-Z0-9._+%'-]*[a-zA-Z0-9])?@[a-zA-Z0-9](?:[-a-zA-Z0-9]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-a-zA-Z0-9]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

  return emailPattern.test(email);
};

export default isValidEmail;
